import React, { ReactNode, useContext } from 'react';
import { StyleSheet, View } from 'react-native';

import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({ children }: { children: ReactNode }) {
  const { storeStates } = useContext(DyteUIContext);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { colors } = storeStates.designSystem;
  const styles = StyleSheet.create({
    container: {
      alignItems: 'center',
      justifyContent: 'space-evenly',
      flexDirection: 'row',
    },
  });
  return <View style={styles.container}>{children}</View>;
}
